import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import DeviceInfo from './DeviceInfo';

const CollapseView = ({viewers, date}) => {
	const [show, setShow] = useState(false);
	return ( 
		<React.Fragment>
			<div className="rtl all_view_item">
				<div className="  d-flex justify-content-between">
					<div className="col-5 text-left px-0">
						<span className="font-weight-bold pt-2">{date}</span>
					</div>
					<div className="col-2 text-center px-0">
						<button
							onClick={() => setShow(!show)}
							aria-controls="example-collapse-text"
							aria-expanded={show}
							className="btn-sm  rounded-circle arrow_button_view"
						>
							<i className={show ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i>
						</button>
					</div>
					<div className="col-5 text-right text-info font-weight-bold pt-1">
						<span className="badge badge-success badge-pill">{viewers.length}</span>
					</div>
				</div>
				<div className=" text-dark">
					<Collapse in={show}>
						<div id="example-collapse-text" className="text-dark  px-0" style={{direction:'ltr'}}>
							{
								viewers.map(viewer => (
									<DeviceInfo 
										key={viewer._id}
										device={viewer.device}
										client={viewer.client}
										ip={viewer.ip}
										city={viewer.city}
										country={viewer.country}
										os={viewer.os}
										pageVisit={viewer.pageVisit}
										isBot={viewer.isBot}
									/>
								))
							}
						</div>
					</Collapse>
				</div>
			</div>
		</React.Fragment>
	 );
}
 
export default CollapseView;

